import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";

export interface QuizType {
  id: number;
  slug: string;
  name: string;
  description: string | null;
  iconKey: string | null;
  iconUrl: string | null;
  colorKey: string | null;
  adminRoute: string;
  order: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateQuizTypeRequest {
  slug: string;
  name: string;
  description?: string;
  iconKey?: string;
  iconUrl?: string | null;
  colorKey?: string;
  adminRoute: string;
  order?: number;
  isActive?: boolean;
}

export type UpdateQuizTypeRequest = Partial<Omit<CreateQuizTypeRequest, "slug">>;

export const quizTypesService = {
  listAdmin: async (): Promise<{ types: QuizType[] }> => {
    return apiClient.get(API_ENDPOINTS.QUIZ_TYPES.ADMIN_LIST);
  },
  listPublic: async (): Promise<{ types: QuizType[] }> => {
    return apiClient.get(API_ENDPOINTS.QUIZ_TYPES.PUBLIC_LIST);
  },
  create: async (data: CreateQuizTypeRequest): Promise<QuizType> => {
    return apiClient.post(API_ENDPOINTS.QUIZ_TYPES.CREATE, data);
  },
  update: async (id: number, data: UpdateQuizTypeRequest): Promise<QuizType> => {
    return apiClient.patch(API_ENDPOINTS.QUIZ_TYPES.UPDATE(id), data);
  },
  toggle: async (id: number): Promise<QuizType> => {
    return apiClient.patch(API_ENDPOINTS.QUIZ_TYPES.TOGGLE(id));
  },
  delete: async (id: number): Promise<{ message: string }> => {
    return apiClient.delete(API_ENDPOINTS.QUIZ_TYPES.DELETE(id));
  },
  reorder: async (ids: number[]): Promise<{ types: QuizType[] }> => {
    return apiClient.patch(API_ENDPOINTS.QUIZ_TYPES.REORDER, { ids });
  },
  uploadIcon: async (file: File): Promise<{ url: string }> => {
    const fd = new FormData();
    fd.append("file", file);
    return apiClient.post(API_ENDPOINTS.QUIZ_TYPES.UPLOAD_ICON, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
